import React from "react";
import {Controller} from "react-hook-form";
import {Box, Button, Container, FormControl, InputLabel, MenuItem, Select, TextField, Typography} from "@mui/material";

export default function Step3(props) {
  // const loadParams = (nm) => {
  //   return sessionStorage.getItem(nm) || "";
  // };
  const saveParams = (nm, val) => {
    return sessionStorage.setItem(nm, val);
  };
  const loadJson = (nm) => {
    return JSON.parse(sessionStorage.getItem(nm)) || [];
  };
  const saveJson = (nm, val) => {
    return sessionStorage.setItem(nm, JSON.stringify(val));
  };
  async function nextStep(val) {
    // const svsCd = val.svsCd;
    // const hourfDt = val.hourfDt;
    // const hourtDt = val.hourtDt;
    // if (!Boolean(svsCd)) {
    //   props.errorFunc({response: {data: {errors: "サービス種類を選択してください。"}}})
    // } else if (!Boolean(hourfDt) || !Boolean(hourtDt)) {
    //   props.errorFunc({response: {data: {errors: "提供時間を入力してください。"}}})
    // } else {
    //   const svsForm = await getServiceForm({ymdDt: props.propState.date, bsJg: props.propState.jgCd, svsCd: svsCd}).catch(error => props.errorFunc(error));
    //   if (Boolean(svsForm)) {
    const svkCd = val.svkCd;
    if (!Boolean(svkCd)) {
      props.errorFunc({response: {data: {errors: "基本サービスを選択してください。"}}})
    } else {
      props.setState({...props.state, activeStep: props.state.activeStep + 1});
      saveParams("activeStep", props.state.activeStep + 1);
    };
    //   };
    // };
  };

  return (
    <Container>
      <Box
        sx = {{display: "flex", mt: 2, mb: 2}}
      >
        {/* <FormControl
          size = "small"
          sx = {{width: "100%"}}
        >
          <InputLabel
            sx = {{zIndex: -1}}
          >
            基本サービス
          </InputLabel>
          <Select
            fullWidth
            label = "基本サービス"
            MenuProps = {{PaperProps: {style: {maxHeight: 200}}}}
          >
          </Select>
        </FormControl> */}
        {Boolean(loadJson("svkCdList").length) &&
        <Controller
          control = {props.control}
          defaultValue = {loadJson("svkCdList").length === 1 ? loadJson("svkCdList")[0][0] : ""}
          name = "svkCd"
          render = {({field}) => (
            <TextField
              fullWidth
              label = "基本サービス"
              SelectProps = {{MenuProps: {style: {maxHeight: 200}}}}
              select
              size = "small"
              sx = {{textAlign: "left", zIndex: "0"}}
              {...field}
            >
              {loadJson("svkCdList").map((select) => (
                <MenuItem
                  key = {"svkCd_" + select[0]}
                  value = {select[0]}
                >
                  {select[1]}
                </MenuItem>
              ))}
            </TextField>
          )}
        />}
        {!Boolean(loadJson("svkCdList").length) &&
        <FormControl
          size = "small"
          sx = {{width: "100%"}}
        >
          <InputLabel
            id = "svk_cd_list_label"
          >
            基本サービス
          </InputLabel>
          <Select
            fullWidth
            label = "基本サービス"
            labelId = "svk_cd_list_label"
          >
          </Select>
        </FormControl>}
      </Box>
      <Box
        sx = {{display: "flex", mt: 2, mb: 2}}
      >
        <Button
          className = "btn-prev"
          onClick = {() => {
            props.setState({...props.state, activeStep: props.state.activeStep - (Boolean(loadJson("svsForm").length) ? 1 : 2)});
            saveParams("activeStep", props.state.activeStep - (Boolean(loadJson("svsForm").length) ? 1 : 2));
            let editScheduleStepper = loadJson("editScheduleStepper");
            props.unregister("svkCd");
            delete editScheduleStepper["svkCd"];
            saveJson("editScheduleStepper", editScheduleStepper);
            sessionStorage.removeItem("svkCdList");
          }}
          sx = {{display: "block", mr: "auto", pt: 0.5, pb: 0.5, width: 120}}
        >
          <Typography
            className = "btn-txt-sm"
          >
            戻る
          </Typography>
        </Button>
        <Button
          className = "btn-submit"
          onClick = {() => nextStep(props.getValues())}
          sx = {{display: "block", ml: "auto", pt: 0.5, pb: 0.5, width: 120}}
        >
          <Typography
            className = "btn-txt-sm"
          >
            次へ
          </Typography>
        </Button>
      </Box>
    </Container>
  );
};
